import List from './List'
import ProductView from './Product'
import ProposalsView from './Proposals'
import LoginView from './Login'
import DecisionTreeView from './DecisionTree'
import RedirectView from './Redirect'

export default [
  {
    path: '/',
    key: 'index',
    exact: true,
    component: List,
  },
  {
    path: '/item/:productId',
    key: 'productDetail',
    exact: true,
    component: ProductView,
  },
  {
    path: '/bundle/:bundleId',
    key: 'bundleDetail',
    exact: true,
    component: ProductView,
  },
  {
    path: '/proposals',
    key: 'proposals',
    exact: true,
    component: ProposalsView,
  },
  {
    path: '/login',
    key: 'login',
    exact: true,
    component: LoginView,
  },
  {
    path: '/decisionTree/:flowId?',
    key: 'decisionTree',
    exact: true,
    component: DecisionTreeView,
  },
  {
    path: '/redirect/:token',
    key: 'handleTokenRedirect',
    exact: true,
    component: RedirectView,
  },
]
